<template>
  <section class="cta__area mb--100">
      <div class="container">
         <div class="cta__inner cta__inner-2 blue-bg fix">
            <div class="cta__shape">
               <img src="../../assets/img/cta/cta-shape.png" alt="">
            </div>
            <div class="row align-items-center">
               <div class="col-xxl-7 col-xl-7 col-lg-7 col-md-6">
                  <div class="cta__content">
                     <h3 class="cta__title">Start learning by Downloading Apps.</h3>
                  </div>
               </div>
               <div class="col-xxl-5 col-xl-5 col-lg-5 col-md-6">
                  <div class="cta__apps d-lg-flex justify-content-end p-relative z-index-1">
                     <a target="_blank" href="https://www.apple.com/app-store/" class="mr-10"><i class="fab fa-apple"></i> Apple Store</a>
                     <a target="_blank" href="https://play.google.com/store/apps" class="active"><i class="fab fa-google-play"></i> Play Store</a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>
</template>

<script>
export default {
   name:'CtaArea'
};
</script>
